import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=a4fdc85c&lang=pug&"
import script from "./CreateOrder.vue?vue&type=script&lang=ts&"
export * from "./CreateOrder.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=a4fdc85c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports